import React, { type ReactNode } from 'react';
import { type QuizListType } from '@/shared/quizList/QuizListType';
import { SearchOrderDropDownMenu } from '@/shared/quizList/SearchField/SearchOrderDropDownMenu';
import { cn } from '@/utils';

/**
 *  @desc 전체 퀴즈 카운트 및 정렬 드롭 다운
 * */
export const SearchMetaBar = (props: QuizListSearchProps) => {
  return <div className={'flex h-[40px] shrink-0 items-center justify-end gap-x-2xs '} data-sentry-component="SearchMetaBar" data-sentry-source-file="SearchMetaBar.tsx">
      <div className={cn('min-w-1/2 flex  justify-center p-sm pr-none px-sm text-body-md-semibold  text-neutral', props.className)}>
        {props.totalCount}
      </div>
      <Divider data-sentry-element="Divider" data-sentry-source-file="SearchMetaBar.tsx" />
      <SearchOrderDropDownMenu data-sentry-element="SearchOrderDropDownMenu" data-sentry-source-file="SearchMetaBar.tsx" />
    </div>;
};
export const SearchMetaBarMobile = (props: QuizListSearchProps) => {
  return <div className={cn('flex h-[40px] w-full items-center justify-between gap-xs', props.className)} data-sentry-component="SearchMetaBarMobile" data-sentry-source-file="SearchMetaBar.tsx">
      <div className={'flex min-w-0 flex-1 items-center px-sm'}>
        {props.totalCount}
      </div>
      <div className={'shrink-0'}>
        <SearchOrderDropDownMenu data-sentry-element="SearchOrderDropDownMenu" data-sentry-source-file="SearchMetaBar.tsx" />
      </div>
    </div>;
};
const Divider = () => {
  return <div className={'border-1 h-[16px] w-[1px] border border-neutral'} data-sentry-component="Divider" data-sentry-source-file="SearchMetaBar.tsx" />;
};
export type QuizListSearchProps = {
  totalCount: ReactNode;
  className?: string;
  eventType: QuizListType;
};